import * as Highchart from 'highcharts';

import { ChartColors } from '../../theme/tokens';

// The colours the chart was given (its own palette, if it has one), so
// resetting a point's colour after a drill-down restores the right one. The
// options as given, not as merged: merged ones fall back to Highcharts' own
// palette rather than the chart colours.
const getChartColors = (chart: Highchart.Chart | undefined): string[] => {
  const colors = chart ? chart.userOptions.colors : undefined;
  return colors && colors.length > 0 ? (colors as string[]) : ChartColors;
};

export default getChartColors;
